import { useEntityAPI } from '../../../redux/entity-api.hook';
import { requestStatusAPI } from '../redux/request-status.slice';

export function useRequestStatusList() {
  return useEntityAPI(requestStatusAPI);
}
